/**
 * The GUI packs, in one list (like `plugins/builtin` for the core): what each built-in plugin
 * adds to the screen beyond its data (`state/packs.ts` says what a pack may add). Only `app/`
 * imports this list: the engine (the board and its windows) never names a pack, and a pack never
 * imports another. Art, Writing and Coding need none: their kinds, fields, templates and play are
 * data the engine draws.
 */
import type { App } from "../app/context";
import type { GuiPack } from "../state/packs";
import { uiux } from "./uiux";

/** Every GUI pack. */
export const PACKS: readonly GuiPack<App>[] = [uiux];
